// extracted by mini-css-extract-plugin
export default {"element":"Conditions_element__PJc-Q","content":"Conditions_content__a1wmt"};